import Axios from "@/plugins/Axios";
import FichaIndividualAee from "../Models/FichaIndividualAee";

export class EducacaoInclusivaService {
  async syncAll(form) {
    const response = await Axios().post(`educacao-inclusiva`, form);
    const payload = response.data;
    return payload;
  }

  async lancar(form) {
    await Axios().post(`educacao-inclusiva/salvar-relatorio`, form);
  }

  async lancarFichaDeDesenvolvimentoBimestral(form) {
    await Axios().post(`educacao-inclusiva/salvar-ficha-de-desenvolvimento-bimestral`, form);
  }

  async carregarFichaDeDesenvolvimentoBimestral(matricula_id, gestaoDeAulasId, bimestre) {
    const response = await Axios().get(
      `educacao-inclusiva/carregar-ficha-de-desenvolvimento-bimestral/${matricula_id}/${gestaoDeAulasId}/${bimestre}`
    );
    const payload = response.data;
    return payload;
  }

  async lancarFichaDeDiarioAtendimento(form) {
    await Axios().post(`educacao-inclusiva/salvar-ficha-de-diario-atendimento`, form);
  }

  async carregarFichaDeDiarioAtendimento(matricula_id, gestaoDeAulasId) {
    const response = await Axios().get(
      `educacao-inclusiva/carregar-ficha-de-diario-atendimento/${matricula_id}/${gestaoDeAulasId}`
    );
    const payload = new FichaIndividualAee(response.data);

    return payload;
  }

  async carregarFichaDeDiarioAtendimentoEdit(id) {
    const response = await Axios().get(
      `educacao-inclusiva/carregar-ficha-de-diario-atendimento-edit/${id}`
    );

    return new FichaIndividualAee(response.data);
  }

  async lancarFichaDeDiarioAtendimentoEdit(form) {
    await Axios().post(`educacao-inclusiva/salvar-ficha-de-diario-atendimento-edit`, form);
  }

  async mudarPresenca(id, justificativa) {
    await Axios().post(`educacao-inclusiva/presenca/${id}`, { justificativa });
  }

  async mudarConfirmacao(id) {
    await Axios().get(`educacao-inclusiva/confirmacao/${id}`);
  }

  async deletar(ficha) {
    const response = await Axios().delete(`educacao-inclusiva/${ficha.id}`);
    const fichaDeletada = response.data;
    return fichaDeletada;
  }

  async salvarPlanejamentoMensalAEE(form) {
    await Axios().post(`educacao-inclusiva/salvar-planejamento-mensal-aee`, form);
  }

  async carregarPlanejamentoMensalAEE(matricula_id, gestao_id, mes_id) {
    const response = await Axios().get(
      `educacao-inclusiva/carregar-planejamento-mensal-aee/${matricula_id}/${gestao_id}/${mes_id}`
    );
    return response.data;
  }

  async carregarPlanoAEE(matricula_id, gestao_id) {
    const response = await Axios().get(
      `educacao-inclusiva/carregar-plano-aee/${matricula_id}/${gestao_id}`
    );
    return response.data;
  }

  async salvarPlanoAEE(form) {
    await Axios().post(`educacao-inclusiva/salvar-plano-aee`, form);
  }
}
export default new EducacaoInclusivaService();
